import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function ServicesGridTrockenbauarbeiten() {
  const features = ["Rigipsdecken", "Neue Wände und Raumteiler", "Abgehängte Decken", "Dämm- und Schallschutzarbeiten"];
  return <section id="services-grid-trockenbauarbeiten" className="bg-background py-12 md:py-16">
      <div className="page-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col items-start">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6">
              Trockenbauarbeiten
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Flexible Raumgestaltung durch professionellen Trockenbau. Neue Wände,
              abgehängte Decken und individuelle Raumlösungen.
            </p>
            
            <ul className="flex flex-col gap-4 mb-10 w-full">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-foreground">
                  <Check className="size-5 text-primary shrink-0" strokeWidth={2.5} />
                  <span className="text-base md:text-lg">{feature}</span>
                </li>)}
            </ul>
            
            <Button size="lg" className="rounded-lg px-8 py-6 text-base font-semibold">
              Angebot anfordern
            </Button>
          </div>

          {}
          <div className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-xl overflow-hidden shadow-md">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/trockenbauarbeiten_service_showcase.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/trockenbauarbeiten_service_showcase.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/trockenbauarbeiten_service_showcase.png-wvc-sizes" alt="Professionelle Trockenbauarbeiten mit Metallständerwerk" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          </div>

        </div>
      </div>
    </section>;
}